import { HTMLDataTrackerProps } from '@/app/types';
import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import LinkButton, { LinkButtonProps } from '@/components/atoms/linkButton';
import LinkButtonSB, {
  LinkButtonSBProps,
  transformFromCMSLink,
} from '@/components/atoms/linkButton/LinkSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { pullDataTrackers } from './utils';

export type ImageTextLinkStrapiProps = {
  image?: ImageSBProps;
  text?: LinkButtonSBProps;
  link: LinkButtonSBProps;
};

const defaultTextButtonProps: Partial<LinkButtonProps> = {
  slim: true,
  textWrap: true,
  variant: 'text',
  color: 'tertiary',
  underline: false,
};

const defaultLinkButtonWrapperProps: Partial<LinkButtonProps> = {
  variant: 'text',
  underline: false,
  classNames: { root: 'px-0 h-6' },
};

export function ImageLinkStrapi(
  props: BlockComponentModel<
    ImageTextLinkStrapiProps,
    /* FIXME: this needs to be typed properly in the future, as of now it uses one
      type for spreading `inner` in all 3 sub-components
    */
    HTMLDataTrackerProps & Record<string, unknown>
  >
) {
  const { block, inner, ...rest } = props;
  const { image, link } = block;

  return (
    <LinkButton
      {...transformFromCMSLink(link)}
      {...pullDataTrackers(inner || {})}
      {...defaultLinkButtonWrapperProps}
    >
      <div className='flex gap-2'>
        {image && <ImageSB block={image} inner={inner} {...rest} />}
        {link.text && (
          <LinkButtonSB
            block={props.block.link}
            inner={{
              ...defaultTextButtonProps,
              ...props.inner,
            }}
          />
        )}
      </div>
    </LinkButton>
  );
}
